export default __webpack_public_path__ + "static/media/compass.7e61c6f9.svg";